import { SkiWaterIcon } from './SkiWaterIcon';

/**
 * author: Michael Irigoyen
 * id 51D8DB1F-FA7C-4527-AD8E-495024CD4E2D
 * name ski-water
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ski-water.svg
 * tags
 * - Sport 
 * - People / Family 
 * - Transportation + Water 
 */
export const HumanSkiWaterIcon = SkiWaterIcon;
export default HumanSkiWaterIcon